import {Component, OnInit} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {ComplainRegisterService} from '../complain-register/complain-register.service';
import {Complain} from '../complain-register/model/complain';

@Component({
  selector: 'app-complain-status',
  templateUrl: './complain-status.component.html',
  styleUrls: ['./complain-status.component.css']
})
export class ComplainStatusComponent implements OnInit {
  complains: Complain[];
  showMsg: boolean = false;
  showTableHeader: boolean = false;

  constructor(private apiService: ComplainRegisterService, private router: Router) {
  }

  ngOnInit(): void {
  }

  getUserComplains(form: NgForm): void {

    this.showMsg = false;
    this.showTableHeader = false;
    this.apiService.getComplain(form.value.complId, 
      form.value.phone, form.value.aadhar).subscribe((complainsFromService: Complain[]) => {
      if(complainsFromService.length > 0) {
        this.complains = complainsFromService;
        this.showTableHeader = true;
      } else {
        this.complains = [];
        this.showMsg = true;
        this.showTableHeader = false;
      }

    });


  }

  reset(form: NgForm) {
    form.resetForm();
    this.complains = [];
    this.showMsg = false;
    this.showTableHeader = false;
  }

  findDetails(complain: Complain) {
    //return this.data2.filter(x => x.whoseData === data.name);
    return [{event: "Sent file to BDO for review and approval", 
     createTime:"2021-06-30 10:20:00"},
     {event: "File received from BDO and awaiting Sarpanch signature",
     createTime:"2021-06-30 10:20:00"}]
  }

  


}
